import { CarryEntityDetail } from '@/components/funds-carry/structure/CarryEntityDetail';
import { PORTAL_CARRY_STRUCTURE_PATH } from '../carryPaths';
import { memberEntity } from '../components/structure/memberStructure';
import { PortalStructureData } from '../components/structure/PortalStructureData';

export function PortalCarryCooperativePage() {
  return (
    <PortalStructureData>
      {(structure, positions) => (
        <CarryEntityDetail
          entity={memberEntity(structure.cooperative, structure, positions)}
          structurePath={PORTAL_CARRY_STRUCTURE_PATH}
          kind="Carry entity"
          description="All carry runs through this cooperative. Members participate directly via their holding company; DR holders via the STAK."
          holdersLabel="Your membership"
          holdersTitle="Your membership"
          holdersNote="Units per fund — vesting and days are shown on the fund itself"
        />
      )}
    </PortalStructureData>
  );
}
